import {
  ColorField,
  useBackgroundSwatches,
} from '@/components/app-editor/color-field';
import { Label } from '@/components/ui/label';
import type { CreateWebsiteBannerDto } from '@/generated/korza-api-client/types.gen';
import { useI18nContext } from '@/i18n/i18n-react';

export interface ColorsPanelProps {
  form: CreateWebsiteBannerDto;
  updateTheme: (patch: Partial<CreateWebsiteBannerDto['theme']>) => void;
}

/** Background and text colours: the fixed palette (with White) + "Outra cor". */
export function ColorsPanel({ form, updateTheme }: ColorsPanelProps) {
  const { LL } = useI18nContext();
  const swatches = useBackgroundSwatches(true);

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label>{LL.websiteBannerPage.theme.backgroundColor()}</Label>
        <ColorField
          label={LL.websiteBannerPage.theme.backgroundColor()}
          value={form.theme.bgColor}
          onChange={(bgColor) => updateTheme({ bgColor })}
          swatches={swatches}
          otherLabel={LL.appEditor.color.other()}
          invalidHexMessage={LL.appEditor.color.invalidHex()}
        />
      </div>
      <div className="space-y-2">
        <Label>{LL.websiteBannerPage.theme.foregroundColor()}</Label>
        <ColorField
          label={LL.websiteBannerPage.theme.foregroundColor()}
          value={form.theme.fgColor}
          onChange={(fgColor) => updateTheme({ fgColor })}
          swatches={swatches}
          otherLabel={LL.appEditor.color.other()}
          invalidHexMessage={LL.appEditor.color.invalidHex()}
        />
      </div>
    </div>
  );
}
